import { useMemo } from "react";
import { Chip } from "../../components/chip/Chip";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";
import { VenueType } from "./BuyerVenueSelection.shared";

export function BuyerVenueSelection({
  selectedVenueTypes,
  setSelectedVenueTypes,
}: {
  selectedVenueTypes?: string[];
  setSelectedVenueTypes: (selectedVenueTypes?: string[]) => void;
}) {
  const { business } = useSellarCurrentBusiness();

  const allVenueTypes = useMemo(() => {
    const businessVenueTypes = business?.Retailer?.venueTypes;
    if (businessVenueTypes) {
      // get default values from array
      const venueValues = new Set(VenueType.map((venue) => venue.value));
      // from the businesses stored in database, remove any that are found in local array
      const filteredBusinessVenues = businessVenueTypes
        .filter((venue) => !venueValues.has(venue))
        .map((venue) => ({
          title: venue,
          value: venue,
        }));

      // merge both customer & default venue types
      return [...filteredBusinessVenues, ...VenueType];
    }

    return VenueType;
  }, [business?.Retailer?.venueTypes]);

  return (
    <div className="flex flex-wrap justify-center gap-2">
      {allVenueTypes?.map((venueType) => (
        <Chip
          key={venueType.value}
          title={venueType.title}
          selected={
            !!selectedVenueTypes && selectedVenueTypes.includes(venueType.value)
          }
          value={venueType.value}
          onClick={(venueTypeValue: string) => {
            if (selectedVenueTypes?.includes(venueTypeValue)) {
              setSelectedVenueTypes(
                selectedVenueTypes.filter((type) => type !== venueTypeValue),
              );
            } else if (!selectedVenueTypes || selectedVenueTypes.length < 3) {
              setSelectedVenueTypes([
                ...(selectedVenueTypes ? selectedVenueTypes : []),
                venueTypeValue,
              ]);
            }
          }}
        />
      ))}
    </div>
  );
}
